import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import {
	CONTAINER_ADMIN_HOME_ID,
	CONTAINER_HOME_ID,
} from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { ShareableLinkSpaceAdminControlsLoader } from '@confluence/shareable-links/entry-points/ShareableLinkSpaceAdminControlsLoader.ts';

export const ShareableLinkSpaceSettingsRoute = () => {
	return <ShareableLinkSpaceAdminControlsLoader />;
};

ShareableLinkSpaceSettingsRoute.NAVIGATION_PARAMS = (
	{ name, params: { spaceKey } }: RouteMatch,
	isNav4Enabled,
) => ({
	Screen: {
		screenEvent: {
			name: 'spaceSettingsShareableLinksScreen',
			id: spaceKey,
		},
		pageState: {
			routeName: name,
			spaceKey,
		},
	},
	MainLayout: {
		navView: isNav4Enabled ? CONTAINER_ADMIN_HOME_ID : CONTAINER_HOME_ID,
		spaceKey,
	},
});
